// Dependencies
import { FC } from "react";

// Components
import ForgotPasswordForm from "~/containers/ForgotPasswordForm";

// Styles
import { StyledForgotPasswordBackground } from "./ForgotPassword.styled";

interface ForgotPasswordProps {}

const ForgotPassword: FC<ForgotPasswordProps> = () => {
  return (
    <StyledForgotPasswordBackground>
      <ForgotPasswordForm />
    </StyledForgotPasswordBackground>
  );
};

export default ForgotPassword;
